export const theme = {
  backgroundColor: '#13132F',
  secondaryBlue: '#2C2C6C',
  blueColor: '#4DB5FF',
  blueColorLight: '#A1DFFFFF',
  secondaryBlueHover: 'rgba(77, 181, 255, 0.4)',
  greyColorText: 'rgba(255, 255, 255, 0.6)',
  whiteColor: '#FFFFFF',
  darkColor: 'rgba(0, 0, 0, 0.3)',
  dangerColor: '#ff3737'
}